export class Group {
    constructor(synth, props = {}) {
        this.children = [];
        this.synth = synth;
        this.name = props.name ?? "group";
    }
    add(...models) {
        models.forEach(model => {
            if (!this.children.includes(model)) {
                this.children.push(model);
            }
        });
        return this;
    }
    apply(fn) {
        this.children.forEach(fn);
        return this;
    }
    camera(camera = this.synth._camera) {
        return this.apply(child => child.camera(camera));
    }
    out(texture = this.synth.defaultOutput) {
        return this.apply(child => {
            child.out(texture);
        });
    }
    vertex(vertex) {
        return this.apply(child => child.vertex(vertex));
    }
    vert(vertex) {
        return this.apply(child => child.vert(vertex));
    }
    fragment(fragment) {
        return this.apply(child => child.fragment(fragment));
    }
    frag(fragment) {
        return this.apply(child => child.frag(fragment));
    }
    uniform(name, value) {
        return this.apply(child => {
            if (typeof name === "string") {
                child.uniform({ [name]: value ?? null });
                return;
            }
            child.uniform(name, value);
        });
    }
    define(name, value) {
        return this.apply(child => child.define(name, value));
    }
    varyngs(varyings) {
        return this.apply(child => child.varyngs(varyings));
    }
    blend(mode) {
        return this.apply(child => child.blend(mode));
    }
    cullFace(mode = "back") {
        return this.apply(child => child.cullFace(mode));
    }
    autoClear(enabled = true) {
        return this.apply(child => child.autoClear(enabled));
    }
    vertexColor(...args) {
        return this.apply(child => child.vertexColor(...args));
    }
    wireframe(enabled = true) {
        return this.apply(child => child.wireframe(enabled));
    }
    primitive(primitive = this.synth.renderer.gl.TRIANGLES) {
        return this.apply(child => child.primitive(primitive));
    }
    point(pointSize = 1) {
        return this.apply(child => child.point(pointSize));
    }
    useTexCoord(enabled = true) {
        return this.apply(child => child.useTexCoord(enabled));
    }
    buffer(name, buffer) {
        return this.apply(child => {
            if (typeof name === "string") {
                if (buffer)
                    child.buffer(name, buffer);
                return;
            }
            child.buffer(name);
        });
    }
    indices(...args) {
        return this.apply(child => child.indices(...args));
    }
    instances(count = 0) {
        return this.apply(child => child.instances(count));
    }
    clear() {
        this.apply(child => child.clear());
        this.children = [];
        return this;
    }
}
